<div class="row">

    <div class="col-12 goldbar d-flex justify-content-center">
        ______________________________________________________________________________
    </div>
</div>